import { LOBBIE_COLORS } from "src/utils/colors";

export const REACT_SELECT_STYLING = {
    control: (provided: any) => ({
        ...provided,
        backgroundColor: LOBBIE_COLORS.secondaryLighter,
        borderColor: LOBBIE_COLORS.secondaryLight,
        cursor: "pointer",
        textAlign: "left",
    }),
    option: (provided: any) => ({
        ...provided,
        cursor: "pointer",
        textAlign: "left",
    }),
    menu: (provided: any) => ({
        ...provided,
        zIndex: 10000,
        textAlign: "left",
    }),
    menuList: (provided: any) => ({
        ...provided,
        zIndex: 10000,
        textAlign: "left",
    }),
};

export const REACT_SELECT_GROUP_STYLES: React.CSSProperties = {
    padding: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontWeight: "bold",
};

export const REACT_SELECT_GROUP_BADGE_STYLES: React.CSSProperties = {
    backgroundColor: "#EBECF0",
    borderRadius: "2em",
    color: "#172B4D",
    display: "inline-block",
    fontSize: 12,
    fontWeight: "normal",
    lineHeight: "1",
    minWidth: 1,
    padding: "0.16666666666667em 0.5em",
    textAlign: "center",
};
